import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=623aaedb"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=623aaedb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports